import { Table as MantineTable } from '@mantine/core';

export const Table = MantineTable.extend({
	defaultProps: {},
});
